import { buildFeatureMap } from '../mapBuilder';
import { FeatureMap } from '../types';

import { FeatureAction, FeatureReducerAction } from './types';

export const FeatureReducer = (
    state: FeatureMap,
    action: FeatureReducerAction
): FeatureMap => {
    switch (action.type) {
        case FeatureAction.InitAsync:
            return buildFeatureMap(action.payload);
        case FeatureAction.ActivateFeature:
            return {
                ...state,
                [action.payload]: true,
            };
        case FeatureAction.DeactivateFeature:
            return {
                ...state,
                [action.payload]: false,
            };
        case FeatureAction.UpdateFeatureState:
            return {
                ...state,
                [action.payload.name]: action.payload.activate,
            };
    }
};
